import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';
import CountryList          from '../Data/CountryList';

let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');

class SelectInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeValue: props.defaultValue ? props.defaultValue : null,
            isValid: (Quote.hasAnswer(this.props.fieldName) === false) ? false : true,
        };
    }

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
        if (window.uorn(this.props.dataValidation)) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    handleValidation(value) {
        // Parse the values as int if the flag is set
        if (this.props.isInt === true) {
            value = parseInt(value);
        }

        // Run validation if required, or just save the data
        if (this.props.dataValidation) {
            let validation = Validation.validate(this.props.dataValidation, value)[0];
            this.setState(Object.assign({}, validation, { activeValue: value }), () => {
                this.props.isValid(validation.isValid);
            });

            Quote.set(this.props.storageKey, value, this.props.source);
        } else {
            Quote.set(this.props.storageKey, value, this.props.source);
        }

        // Run any callback functions if needed
        if (this.props.callbackFunction) {
            this.props.callbackFunction(value);
        }
    }

    render() {
        let self = this;
        let options;
        if (this.props.isCountrySelection) {
            let countries = CountryList;
            options = countries.map(function(item, index) {
                return (
                    <option key={index} value={item.option_value}>{item.option_text}</option>
                );
            });
        } else {
            options = self.props.options.map(function(item, index) {
                return (
                    <option key={index} value={item.option_value}>{item.option_text}</option>
                );
            }, this);
        }

        return (
            <div className="question-input">

                <select
                    name={this.props.fieldName}
                    id={this.props.fieldName}
                    onBlur={(event) => { this.handleValidation(event.target.value); }}
                    defaultValue={this.props.defaultValue}
                    >
                    // the default value is a blank string because html only supports
                    // strings
                    <option value={''}>{this.props.defaultText}</option>
                    {options}
                </select>

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

SelectInput.propTypes = {
    options:            PropTypes.array,
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    callbackFunction:   PropTypes.func,
    defaultValue:       PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    defaultText:        PropTypes.string,
    dataValidation:     PropTypes.string,
    isCountrySelection: PropTypes.bool,
    source:             PropTypes.string,
    isValid:            PropTypes.func,
    isInt:              PropTypes.bool,
};

SelectInput.defaultProps = {
    defaultText: '-- please select --'
};

export default SelectInput;


// WEBPACK FOOTER //
// ./src/components/Fields/SelectInput.js